<script>
import { required } from "vuelidate/lib/validators";
import Middleware from "@/helpers/middlewares";
import InboxService from "@/helpers/APIService/inbox.service";
import errorHandler from "@/helpers/errorHandler";
export default {
  data() {
    return {
      textMessageIso: null,
      chatGroup: {
        group_name: null,
        group_tags: [],
        number: "",
        textMessage: "",
      },
      submittedChat: false,
      isAddNewChat: false,
    };
  },
  validations: {
    chatGroup: {
      textMessage: { required },
      number: { required },
    },
  },
  mounted() {},
  methods: {
    async handleChatAdding(data) {
      this.submittedChat = true;

      // stop here if form is invalid
      this.$v.chatGroup.$touch();
      if (this.$v.chatGroup.$invalid) {
        return;
      } else {
        let tagz = [];
        data.group_tags.map((tag) => {
          tagz.push(tag.value);
        });
        let dataToAdd = {
          group_send_number: this.textMessageIso + data.number,
          msg_content: data.textMessage,
          tagged_by: tagz,
        };
        this.isAddNewChat = true;
        try {
          const response = await InboxService.addInboxGuestGroups(dataToAdd);
          if (response) {
            this.isAddNewChat = false;
            this.$bvModal.hide("add-chat");
            this.chatGroup.textMessage = null;
            this.chatGroup.number = "";
            this.submittedChat = false;
            Middleware.notification("Successfully added !!", "success");
            this.$root.$emit("relaodPage");
          }
        } catch (error) {
          this.isAddNewChat = false;
          errorHandler(error);
        }
      }
    },
    // Method is used for handling country change in vue-tel-input
    countryChange(code) {
      this.textMessageIso = code.dialCode;
    },
  },
};
</script>
<template>
  <b-tabs justified nav-class="nav-tabs-custom" content-class="pt-3">
    <b-tab active>
      <template v-slot:title>
        <span class="d-inline-block d-sm-none">
          <i class="fas fa-home"></i>
        </span>
        <span class="d-none d-sm-inline-block">Compose new message</span>
      </template>
      <b-form-group class="mb-3">
        <label>Mobile Number <span class="text-danger">*</span></label>
        <vue-tel-input
          v-model="chatGroup.number"
          :autoFormat="false"
          :autoDefaultCountry="false"
          :defaultCountry="textMessageIso"
          :validCharactersOnly="true"
          :dropdownOptions="{
            showDialCodeInList: true,
            showDialCodeInSelection: true,
            showFlags: true,
            width: '390px',
            showSearchBox: true,
          }"
          @country-changed="countryChange(...arguments)"
          :class="{
            'is-invalid': submittedChat && $v.chatGroup.number.$error,
          }"
        ></vue-tel-input>
        <div
          v-if="submittedChat && $v.chatGroup.number.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.chatGroup.number.required"
            >Mobile Number is required.</span
          >
        </div>
      </b-form-group>
      <b-form-group class="mb-3">
        <label for="textMessage"
          >Message <span class="text-danger">*</span></label
        >
        <b-form-textarea
          id="name-input"
          v-model.trim="chatGroup.textMessage"
          rows="3"
          placeholder="Enter your message"
          autocomplete="off"
          type="text"
          :class="{
            'is-invalid': submittedChat && $v.chatGroup.textMessage.$error,
          }"
        ></b-form-textarea>
        <div
          v-if="submittedChat && $v.chatGroup.textMessage.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.chatGroup.textMessage.required">
            Message is required.
          </span>
        </div>
      </b-form-group>
      <div class="row mt-2">
        <div class="col-md-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="
              () => {
                this.$root.$emit('cancelAddition', true);
              }
            "
            >Cancel
          </b-button>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            @click="handleChatAdding(chatGroup)"
            :class="{ disabled: isAddNewChat }"
          >
            <i
              v-if="isAddNewChat"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Send
          </b-button>
        </div>
      </div>
    </b-tab>
  </b-tabs>
</template>
